"use client";
import Home from "../about-us/home";
import Vision from "../about-us/vision";
import Hero from "../about-us/hero";
import Discover from "../about-us/discover";
import TawkTo from "../componenets/Tawko";
import Navbar from "../componenets/Navbar";
import Footer from "../componenets/Footer";
function page() {
  return (
    <div>
      <head>
        <title>About Prestige Ride | Premium Black Car Service</title>
        <meta
          name="description"
          content="From airport transfers and off-site events to city to city rides, book your professional chauffeurs and make your travel experience exceptional."
        />

        {/* OG Tags */}
        <meta property="og:url" content="https://www.prestigeride.com/about" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="About Prestige Ride | Premium Black Car Service"
        />
        <meta
          property="og:description"
          content="From airport transfers and off-site events to city to city rides, book your professional chauffeurs and make your travel experience exceptional."
        />
        <meta
          property="og:image"
          content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
        />

        {/* Twitter Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="prestigeride.com" />
        <meta
          property="twitter:url"
          content="https://www.prestigeride.com/about"
        />
        <meta
          name="twitter:title"
          content="About Prestige Ride | Premium Black Car Service"
        />
        <meta
          name="twitter:description"
          content="From airport transfers and off-site events to city to city rides, book your professional chauffeurs and make your travel experience exceptional."
        />
        <meta
          name="twitter:image"
          content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
        />

        <meta name="robots" content="index, follow" />
        <meta
          name="keywords"
          content="
        Black car service,
        Airport transfers,
        Chauffeur services,
        Point-to-point service,
        City tours,
        City-to-city rides,
        Meetings and offsite events,
        Client and partner travels,
        Hourly hire,
        Special events,
        Luxury transportation provider,
        Premium chauffeur services,
        Professional airport transfers,
        Seamless point-to-point rides,
        Exclusive city tours,
        City-to-city travel in style,
        Tailored meetings and events transport,
        VIP client and partner journeys,
        Flexible hourly hire options,
        Upscale services for special events,
        Prestige Ride black car service,
        Personalized chauffeur-driven rides,
        Executive airport transfers,
        Efficient point-to-point transport,
        Guided city tours in luxury,
        Seamless city-to-city journeys,
        Corporate meetings and events transport,
        Client and partner travel excellence,
        Flexible hourly transportation options,
        Premium services for memorable events."
        />
        <link rel="canonical" href="https://www.prestigeride.com/about-us" />
      </head>
      <TawkTo />
      <Navbar />
      <Hero />
      <Home />
      <Vision />
      <Discover />
      <Footer />
    </div>
  );
}

export default page;
